import { createRoute } from '@tanstack/react-router';
import { PujcovnaPrehledPage } from '@/modules/pujcovna/PujcovnaPrehledPage';
import { parseRezervaceUrlSearch } from '@/modules/pujcovna/rezervace-url';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/prehled',
  validateSearch: parseRezervaceUrlSearch,
  component: PujcovnaPrehledPage,
});
